var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarePlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2012 19.5V12.3C38.2012 8.51965 38.2012 6.62947 37.4655 5.18556C36.8183 3.91547 35.7857 2.88285 34.5156 2.23571C33.0717 1.5 31.1815 1.5 27.4012 1.5H13.0012C9.22082 1.5 7.33064 1.5 5.88674 2.23571C4.61664 2.88285 3.58402 3.91547 2.93688 5.18556C2.20117 6.62947 2.20117 8.51965 2.20117 12.3V35.7C2.20117 39.4804 2.20117 41.3705 2.93688 42.8144C3.58402 44.0845 4.61664 45.1171 5.88674 45.7643C7.33064 46.5 9.22082 46.5 13.0012 46.5H20.2012M21.3262 21.75H11.2012M13.4512 30.75H11.2012M29.2012 12.75H11.2012M31.445 30.3688C29.6456 28.3236 26.6449 27.7734 24.3904 29.6463C22.1359 31.5191 21.8184 34.6504 23.5889 36.8654C25.3595 39.0803 31.445 44.25 31.445 44.25C31.445 44.25 37.5306 39.0803 39.3011 36.8654C41.0716 34.6504 40.7929 31.4994 38.4996 29.6463C36.2063 27.7931 33.2444 28.3236 31.445 30.3688Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePlans);
export default __webpack_public_path__ + "static/media/CarePlans.f3eb7346b1e0dc31af2a29ddc989d19a.svg";
export { ForwardRef as ReactComponent };